import { BoundingBox } from 'dashboard/models/document';

export const boundingBoxArea = (boundingBox: BoundingBox) => {
  const { left, right, top, bottom } = boundingBox;
  return (bottom - top) * (right - left);
};

export const boundingBoxesOverlap = (boundingBox: BoundingBox, otherBoundingBox: BoundingBox) => {
  const { left, right, top, bottom } = boundingBox;
  const {
    left: otherLeft,
    right: otherRight,
    top: otherTop,
    bottom: otherBottom,
  } = otherBoundingBox;
  const maxLeft = Math.max(left, otherLeft);
  const maxTop = Math.max(top, otherTop);
  const minRight = Math.min(right, otherRight);
  const minBottom = Math.min(bottom, otherBottom);
  return !(minRight < maxLeft || minBottom < maxTop);
};
